module.exports = __webpack_public_path__ + "static/media/united-states.36ab476e.svg";